export default __webpack_public_path__ + "static/media/ls-line-efficiency-losses.7d9836f7.svg";